module.exports = __webpack_public_path__ + "static/media/otp-icon.d3e9f3ad.png";